import "core-js/modules/es.string.link.js";
export var tabsPortalTokens = {
  hasLastTabMarginRight: true,
  focusBoxShadowParams: "0 0 3px 1px",
  colors: {
    textBase: function textBase(_ref) {
      var color = _ref.color;
      return color.text.black.base;
    },
    textHover: function textHover(_ref2) {
      var color = _ref2.color;
      return color.text.link.hover;
    },
    textSelected: function textSelected(_ref3) {
      var color = _ref3.color;
      return color.text.black.base;
    },
    textHoverSelected: function textHoverSelected(_ref4) {
      var color = _ref4.color;
      return color.text.black.base;
    },
    textDisabled: function textDisabled(_ref5) {
      var color = _ref5.color;
      return color.text.black.disable;
    },
    marker: function marker(_ref6) {
      var color = _ref6.color;
      return color.importance.primary.base;
    },
    borderFocus: function borderFocus(_ref7) {
      var color = _ref7.color;
      return color.border.focus.base;
    },
    hr: function hr(_ref8) {
      var color = _ref8.color;
      return color.border.hr.base;
    },
    iconBase: function iconBase(_ref9) {
      var palette = _ref9.palette;
      return palette.neutralsBlack.hex50;
    },
    iconHover: function iconHover(_ref10) {
      var palette = _ref10.palette;
      return palette.neutralsBlack.hex50;
    },
    iconDisabled: function iconDisabled(_ref11) {
      var palette = _ref11.palette;
      return palette.neutralsBlack.hex50;
    }
  },
  defaultSize: "m",
  sizes: {
    s: {
      marginRight: 24,
      paddingTop: 12,
      paddingBottom: 16,
      markerHeight: 2,
      tabsContainerPb: 16,
      hrHeight: 1,
      focusBorderRadius: 5
    },
    m: {
      marginRight: 32,
      paddingTop: 14,
      paddingBottom: 18,
      markerHeight: 3,
      tabsContainerPb: 24,
      hrHeight: 1,
      focusBorderRadius: 6
    },
    l: {
      marginRight: 40,
      paddingTop: 16,
      paddingBottom: 20,
      markerHeight: 3,
      tabsContainerPb: 32,
      hrHeight: 1,
      focusBorderRadius: 7
    }
  }
};